import React from "react";
import { useSelector } from "react-redux";
import { format, addDays } from "date-fns";

import Row from "../Layout/Row";
import Col from "../Layout/Col";
import { useGetDayName } from "../../helpers/dateHelpers";
import { getTimeLineValues } from "../../helpers/calendarHelpers";
import {
    getCalendarEndDate,
    getCalendarStartDate,
    getWorkTimeEnd,
    getWorkTimeStart,
} from "../../redux/selectors/calendarSelectors";
import CalendarBodyPrintView from "./CalendarBodyPrintView";
import TimeLine from "../Calendar/TimeLine";

const WeekCalendarPrintView = () => {
    const calendarStartDate = useSelector(getCalendarStartDate);
    const calendarEndDate = useSelector(getCalendarEndDate);
    const workTimeStart = useSelector(getWorkTimeStart);
    const workTimeEnd = useSelector(getWorkTimeEnd);
    const days = [
        calendarStartDate,
        addDays(calendarStartDate, 1),
        addDays(calendarStartDate, 2),
        addDays(calendarStartDate, 3),
        addDays(calendarStartDate, 4),
        addDays(calendarStartDate, 5),
        addDays(calendarEndDate, -1),
    ];
    const dayNames = [
        useGetDayName(days[0]),
        useGetDayName(days[1]),
        useGetDayName(days[2]),
        useGetDayName(days[3]),
        useGetDayName(days[4]),
        useGetDayName(days[5]),
        useGetDayName(days[6]),
    ];
    const timeLineValues = getTimeLineValues(
        workTimeStart,
        workTimeEnd,
        "week"
    );

    return (
        <div className="calendar-container">
            <div className="calendar-head">
                <Row>
                    <Col className="calendar-head-event"></Col>
                    {days.map((day, index) => (
                        <Col className="calendar-head-day" key={index}>
                            {dayNames[index]}
                            <br />
                            {format(day, "dd.MM.yyyy")}
                        </Col>
                    ))}
                </Row>
            </div>
            <TimeLine timeLineValues={timeLineValues} />
            <div className="calendar-body-container">
                <div className="calendar-body">
                    <div className="body-timeline">
                        {timeLineValues.map((tl, index) => (
                            <React.Fragment key={index}>
                                {tl.showLine && (
                                    <div
                                        className="line"
                                        style={{
                                            marginLeft: `${tl.step}px`,
                                        }}
                                    />
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                    <CalendarBodyPrintView />
                </div>
            </div>
        </div>
    );
};

export default WeekCalendarPrintView;
